import React, { Component } from 'react'
import { randomNum } from 'helper'

const colors = ['#e28a8a', '#f7e4e4', '#b68792', '#8396a7', '#8d9a8c']

class Keyword extends Component {
  render() {
    const { keyword, index } = this.props
    const height = randomNum(40, 80)

    return (
      <div
        style={{
          height,
          width: '100%',
          maxWidth: 400,
          margin: '0 auto',
          backgroundImage: 'linear-gradient(to top, #45495a, #414557)',
          boxShadow: '0 8px 10px 0 rgba(7, 8, 16, 0.1)',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            width: 300,
            margin: '0 auto',
            fontSize: height * 0.4,
            fontWeight: 600,
            color: colors[index],
          }}
        >
          {keyword}
        </div>
      </div>
    )
  }
}

export default Keyword
